import React from "react";
import { Paper, Typography } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import PrimaryButton from "../../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import config from "../../../../../config";
import { BaseURL } from "../../../../../Hooks/URL";

function DownloadSection({ 
  filePath, 
  title = "Download Mission PDF",
  variant = "large" // "large" for file upload, "small" for MCQ
}) {
  if (!filePath) return null;

  const isSmall = variant === "small";

  return (
    <Paper
      elevation={4}
      sx={{
        flex: 1,
        p: isSmall ? 3 : { xs: 3, md: 5 },
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#fff",
        minWidth: 260,
        mb: { xs: 3, md: 0 },
        boxShadow: "0 4px 32px 0 #b3b3b320",
        textAlign: isSmall ? "center" : "left",
      }}
    >
      <CloudDownloadIcon
        sx={{
          fontSize: isSmall ? 40 : 60,
          color: config.PRIMARY_COLOR,
          mb: 1,
        }}
      />
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, fontSize: 18 }}>
        {title}
      </Typography>
      <span style={{ display: "block", width: "fit-content" }}>
        <a
          href={`${BaseURL}/${filePath}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            width: "100%",
            display: "block",
            width: "fit-content",
          }}
        >
          <PrimaryButton
            classBtn={"center"}
            btnType={"button"}
            text={"Download PDF"}
            style={{
              textTransform: "capitalize",
              minWidth: "180px",
              borderRadius: "5px",
              color: config.SECONDARY_COLOR,
              backgroundColor: config.PRIMARY_COLOR,
              fontWeight: 700,
              fontSize: 18,
              boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
            }}
          />
        </a>
      </span>
    </Paper>
  );
}

export default DownloadSection;

